import { Action as AnyAction } from '@reduxjs/toolkit';
import { signInFailed, signInSuccess } from './auth.action';


export type AuthState = {
    readonly accessToken: string | null;
};

const INITIAL_STATE: AuthState = {
    accessToken: null,
};

export const authReducer = (state = INITIAL_STATE, action: AnyAction) => {
    if (signInSuccess.match(action)) {
        return { ...state, ...action.payload };
    }

    if (
        signInFailed.match(action)
    ) {
        return { ...state, accessToken: null, };
    }

    return state;
};